module.exports = __webpack_public_path__ + "img/dryva-wf-2.0200c91f.jpg";